// extracted by mini-css-extract-plugin
module.exports = {"info":"OnlineReturnsInfo_info__gbocn","returnsButton":"OnlineReturnsInfo_returnsButton__wrPhd"};